import React, { useContext, useState } from 'react';
import Button, { BUTTON_STATUSES } from '@src/components/Button';
import CloseIcon from '@src/assets/images/Subnav/Close.svg';
import PlusIcon from '@src/assets/images/Subnav/Plus.svg';
import classnames from 'classnames';

import {Context} from '../../context';
import './Menu.scss'
import cookie from "js-cookie";

const Menu = () => {

  const {hideMenu} = useContext(Context)
  const [productState, setProductState] = useState(false)
  const [actionsState, setActionsState] = useState(false)

  const toSignIn = () => {
    const paramsCookie = cookie.get('params')

    let params = ''

    if (paramsCookie) {
      params = paramsCookie + '&redirect=credista'
    }

    window.location.href =`https://budgett.ru/login${params}`
  }

  return (
    <div className="mobile-menu">
      <header className='mobile-menu__header'>
        <Button
          onClick={()=> hideMenu()}
          status={BUTTON_STATUSES.ACTIVED}
        >
          <div onClick={toSignIn} className='text'>Личный кабинет</div>
        </Button>
        <Button
          onClick={() => hideMenu()}
        >
          <div className='icon'>
            <img src={CloseIcon} alt='Menu' />
          </div>
        </Button>
      </header>
      <ul className="mobile-menu__tags">
        <li className='mobile-menu__item'>
          <a className="mobile-menu__link" onClick={() => hideMenu()} href='/#conditions'>Условия</a>
        </li>

        <li className='mobile-menu__item'>
          <a className="mobile-menu__link" href='/#creditline' onClick={()=> hideMenu()}>Кредитная линия</a>
        </li>

        <li className='mobile-menu__item'>
          <Button onClick={()=> {
            setActionsState(false);
            setProductState(!productState);
          }}>
            <div className='mobile-menu__text'>Продукты</div>
            <div className={classnames('icon', {'mobile-menu__icon_show': productState})}><img src={PlusIcon} alt='PlusIcon' /></div>
          </Button>
          <ul className={classnames('mobile-menu__sub-tags', {'mobile-menu__sub-tags_show': productState})}>
            <li className='mobile-menu__sub-item'>
              <a href='/#standard' onClick={()=> hideMenu()}>Стандарт</a>
            </li>
            <li className='mobile-menu__sub-item'>
              <a href='/#percentage' onClick={()=> hideMenu()}>Только проценты</a>
            </li>
            <li className='mobile-menu__sub-item' >
              <a  href='/#payment_deferment' onClick={()=> hideMenu()}>До зарплаты</a>
            </li>
          </ul>
        </li>

        <li className='mobile-menu__item'>
          <Button onClick={()=> {
            setProductState(false);
            setActionsState(!actionsState);
          }}>
            <div className='mobile-menu__text'>Действия</div>
            <div className={classnames('icon', {'mobile-menu__icon_show': actionsState})}><img src={PlusIcon} alt='PlusIcon' /></div>
          </Button>
          <ul className={classnames('mobile-menu__sub-tags', {'mobile-menu__sub-tags_show': actionsState})}>
            <li className='mobile-menu__sub-item'>
              <a href='/#gettingfunds' onClick={()=> hideMenu()}>Получение и возврат</a>
            </li>
            <li className='mobile-menu__sub-item' >
              <a href='/#stepssignup' onClick={()=> hideMenu()}>Этапы регистрации</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
};

export default Menu;
